import { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, Space, Popconfirm, message, Upload, Image } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import API from '../api/client';
import { BACKEND_URL } from '../../config';

const PartnersPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [logoUrl, setLogoUrl] = useState('');
  const [uploading, setUploading] = useState(false);
  const [form] = Form.useForm();

  const fetchData = async () => {
    setLoading(true);
    try { const res = await API.get('/partners'); setData(res.data); }
    catch { message.error('Veriler yüklenemedi'); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const openCreate = () => {
    setEditingId(null);
    setLogoUrl('');
    form.resetFields();
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditingId(record._id);
    setLogoUrl(record.logo || '');
    form.setFieldsValue(record);
    setModalOpen(true);
  };

  const handleUpload = async (file) => {
    setUploading(true);
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await API.post('/upload', formData);
      const url = `${BACKEND_URL}${res.data.url}`;
      setLogoUrl(url);
      form.setFieldsValue({ logo: url });
      message.success('Logo yüklendi');
    } catch {
      message.error('Logo yüklenemedi');
    }
    setUploading(false);
    return false;
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      if (editingId) {
        await API.put(`/partners/${editingId}`, values);
        message.success('Güncellendi');
      } else {
        await API.post('/partners', values);
        message.success('Eklendi');
      }
      setModalOpen(false);
      fetchData();
    } catch { /* validation */ }
  };

  const handleDelete = async (id) => {
    await API.delete(`/partners/${id}`);
    message.success('Silindi');
    fetchData();
  };

  const columns = [
    {
      title: 'Logo', dataIndex: 'logo', key: 'logo', width: 70,
      render: (url) => url ? <Image src={url} width={50} height={50} style={{ objectFit: 'contain', borderRadius: 4 }} /> : '-',
    },
    { title: 'Marka Adı', dataIndex: 'name', key: 'name' },
    { title: 'Kısaltma', dataIndex: 'initial', key: 'initial' },
    {
      title: 'İşlem', key: 'actions', width: 120,
      render: (_, record) => (
        <Space>
          <Button icon={<EditOutlined />} size="small" onClick={() => openEdit(record)} />
          <Popconfirm title="Silmek istediğinize emin misiniz?" onConfirm={() => handleDelete(record._id)}>
            <Button icon={<DeleteOutlined />} size="small" danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <h2 style={{ margin: 0 }}>Marka Yönetimi</h2>
        <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>Yeni Marka</Button>
      </div>
      <Table columns={columns} dataSource={data} rowKey="_id" loading={loading} />
      <Modal
        title={editingId ? 'Marka Düzenle' : 'Yeni Marka'}
        open={modalOpen}
        onOk={handleSave}
        onCancel={() => setModalOpen(false)}
        okText="Kaydet"
        cancelText="İptal"
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="Marka Adı" rules={[{ required: true, message: 'Marka adı gerekli' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="initial" label="Kısaltma (logo yoksa gösterilir)">
            <Input placeholder="DB" maxLength={4} />
          </Form.Item>
          <Form.Item name="logo" label="Logo">
            <Input style={{ display: 'none' }} />
          </Form.Item>
          <div style={{ marginBottom: 16, marginTop: -8 }}>
            <Upload showUploadList={false} beforeUpload={handleUpload} accept="image/*">
              <Button icon={<UploadOutlined />} loading={uploading}>Logo Yükle</Button>
            </Upload>
            {logoUrl && (
              <div style={{ marginTop: 8 }}>
                <Image src={logoUrl} width={100} style={{ objectFit: 'contain' }} />
              </div>
            )}
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default PartnersPage;
